export { default as search } from './search'
export { default as friendsList } from './friendsList'
export { default as userInfo } from './userInfo'
export { default as chat } from './chat'
export { default as documentary } from './documentary'
export { default as opportunity } from './opportunity'
export { default as recorder } from './recorder'
export { default as syncChart } from './syncChart'




// WEBPACK FOOTER //
// ./src/views/customerservice/components/index.js